import { decode } from 'he';
import {
  PDF_PRINT_IFRAME_ID,
  REACT_TO_PRINT_IFRAME_ID,
} from '../pages/Article/ArticleContent/ArticleContent.constants';

type UpdateHtmlFunction = (element: HTMLElement) => void;

export const modifyHtml = (html: string, updateHtml: UpdateHtmlFunction): string => {
  const container = document.createElement('div');
  container.innerHTML = html;
  updateHtml(container);
  return container.innerHTML;
};

export const printPdf = (): void => {
  const pdf = document.getElementById(PDF_PRINT_IFRAME_ID) as HTMLIFrameElement | null;
  if (pdf) {
    pdf.contentWindow!.focus();
    pdf.contentWindow!.print();
  }
};

export const setDocumentTitle = (title: string, targetDocument?: Document): void => {
  const domDocument = targetDocument ?? document;
  if (domDocument) {
    domDocument.title = decode(`CreditSights - ${title}`);
  }
};

export const setPrintIframeTitle = (title: string): void => {
  const documentPrintWindow = document.getElementById(REACT_TO_PRINT_IFRAME_ID) as HTMLIFrameElement | null;
  if (!documentPrintWindow) {
    return;
  }

  const domDocument = documentPrintWindow.contentDocument || documentPrintWindow.contentWindow?.document;
  setDocumentTitle(title, domDocument);
};
